import { Paper, Typography } from "@mui/material";

import CircularLoading from "../../../../../common/components/progress/CircularLoading";
import { memo } from "react";

interface INodesUptimeTableNoRowsOverlayProps {
  loading?: boolean;
}

const SystemHealthNoRowsOverlayComponent = ({
  loading,
}: INodesUptimeTableNoRowsOverlayProps): JSX.Element => {
  return (
    <Paper
      sx={{
        height: "240px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {loading ? (
        <CircularLoading />
      ) : (
        <>
          <Typography variant="h4">No data to display</Typography>
          <Typography variant="body1Regular" color="text.secondary">
            There is no activated model or the data is no recorded{" "}
          </Typography>
        </>
      )}
    </Paper>
  );
};

const SystemHealthNoRowsOverlay = memo(SystemHealthNoRowsOverlayComponent);

export default SystemHealthNoRowsOverlay;
